import { useEffect, useRef, useState } from 'react';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { Loader } from '@/components/Loader';
import { useBrandingColors } from '@/hooks/useBrandingColors';
import { useCustomFavicon } from '@/hooks/useCustomFavicon';
import { useInitializeLastUtilizedOrganization } from '@/hooks/useInitializeLastUtilizedOrganization';
import { PreloadQueriesLayout } from '@/layouts/PreloadQueriesLayout';
import { SocketLayout } from '@/layouts/SocketLayout';
import { PageNotFound } from '@/pages';
import { useUsersStore } from '@/stores/users';
import { useWhitelabelStore } from '@/stores/whitelabel';
import { SESSION_STORAGE_KEYS, LOCAL_STORAGE_KEYS } from '@/utils/constants';
import { getLinkToLogin } from '@/utils/getLinkToLogin';

export const RequiredAuthLayout = () => {
  const fetchUserData = useUsersStore((state) => state.fetchUserData);
  const currentWhitelabel = useWhitelabelStore(
    (state) => state.currentWhitelabel,
  );
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(true);
  useBrandingColors();
  useCustomFavicon();
  const { isResolving } = useInitializeLastUtilizedOrganization();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const redirectInstitutionId = useRef(searchParams.get('institutionId'));

  useEffect(() => {
    const fetching = async () => {
      const token = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
      if (!token) {
        sessionStorage.setItem(
          SESSION_STORAGE_KEYS.REDIRECT_PATH,
          window.location.pathname + window.location.search,
        );
        navigate(getLinkToLogin());
        return;
      }
      const localId = localStorage.getItem(
        LOCAL_STORAGE_KEYS.CURRENT_INSTITUTION_ID,
      );
      try {
        await fetchUserData(
          currentWhitelabel?.id ??
            redirectInstitutionId.current ??
            localId ??
            undefined,
        );
      } catch (error) {
        console.error(error);
        setIsError(true);
        navigate(getLinkToLogin());
      }
      setLoading(false);
    };
    void fetching();
  }, [currentWhitelabel?.id, fetchUserData, navigate]);

  if (loading || isResolving) {
    return <Loader />;
  }

  if (isError) return <PageNotFound />;

  return (
    <SocketLayout>
      <PreloadQueriesLayout>
        <Outlet />
      </PreloadQueriesLayout>
    </SocketLayout>
  );
};
